import {useEffect, useState} from "react";
import {createVivaOrder, getLink, getOrder, sendEmail, sendText,} from "../api/apis";
import {useNavigate, useParams} from "react-router";
import BottomSheet from "../components/BottomSheet";
import SwishModal from "../Modals/SwishModal";
import {useApp} from "../Context";
import PaymentOptions from "../components/PaymentOptions";

export default function OrderStatusPage() {
    const { orderId, restaurant } = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [sbo, setSbo] = useState(null)
    const [showCart, setShowCart] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetchCount, setFetchCount] = useState(0);
    const [send, setSend] = useState(false)
    const [swish, setSwish] = useState(null)
    const [recieptLink, setRecieptLink] = useState(null);
    const {sid, orderids, setOrderids} = useApp()

    function handleLocal() {
        const id = parseInt(orderId);
        let isChanged = false;

        const updatedList = orderids.map(item => {
            if (item.id === id && item.paid === false) {
                isChanged = true;
                return { ...item, paid: true };
            }
            if(parseInt(item) === id){
                isChanged = true;
                return {id: item, paid: true};
            }
            return item

        });

        if (isChanged) {
            console.log(updatedList)
            setOrderids(updatedList); // context handles localStorage sync
        }
    }



    useEffect(() => {
        let fetchCount = 0;
        let intervalId;

        const fetchOrderStatus = () => {
            getOrder(orderId).then((result) => {
                setOrder(result.order);
                setSbo(result.sbo);
                setLoading(false);
                setFetchCount((prev) => prev + 1);

                const isPaid = result.order?.order00?.paid === "1";

                if (isPaid) {
                    clearInterval(intervalId);
                    fetchLink(result.order)
                    handleLocal()
                } else {
                    fetchCount += 1;

                    if (fetchCount === 4) {
                        clearInterval(intervalId);
                        intervalId = setInterval(fetchOrderStatus, 10000);
                    }
                }
            });
        };

        intervalId = setInterval(fetchOrderStatus, 1000);

        return () => clearInterval(intervalId);
    }, [orderId]);







    if (loading) {
        return (
            <div className="container text-center mt-5">
                <div className="spinner-border text-primary primaryText mt-3" role="status">
                </div>
            </div>
        );
    }

    async function fetchLink(order){
        const note = order.order00.orderid

        const link = await getLink(note);

        setRecieptLink(link?.link)
    }

    const goToPage = async() => {
        if(recieptLink){
            window.open(recieptLink, '_blank').focus();
        }

    }

    const handleSwish = () => {
        setSwish(true);
    }

    const handleViva = () => {
        createVivaOrder(orderId)
    }


    if (!order) {
        return (
            <div className="container text-center mt-5">
                <h3 className="text-danger">Ordern kunde inte hittas</h3>
            </div>
        );
    }

    function OrderModal(){
        return(
            <BottomSheet showModal={showCart} setShowModal={setShowCart} headerText="Orderöversikt" showFooter={false}>

                {sbo?.cart?.rows?.map((item, index) => {
                    const txoList = Object.keys(item.txo).map(key=>{
                        const {m0pris, m0text} = item.txo[key]
                        return {m0pris, m0text}})

                    const sxoList = Object.keys(item.sxo).map(key=>{
                        const {m0pris, m0text} = item.sxo[key]
                        return {m0pris, m0text}})
                                return <div key={index} className="mb-2">
                                    {/* Main Item */}
                                    <div className="d-flex justify-content-between">
                                        <span className="fw-bold text-dark">{item.text.toSwe()}</span>
                                        <span className="fw-bold">{(item.price / 100).toFixed(2)} SEK</span>
                                    </div>

                                    {/* Add-ons (if any) */}
                                    {txoList.length > 0 && (
                                        <div style={{ marginLeft: "15px", marginTop: "2px" }}>
                                            {txoList.map((a, i) => {
                                                console.log(a)
                                                return <div key={i} className="d-flex justify-content-between">
                                                    <span className="text-muted"> {a.m0text.toSwe()}</span>
                                                    <span className="text-muted">{parseInt(a.m0pris).toFixed(2)} SEK</span>
                                                </div>
    })}
                                        </div>
                                    )}

                                    {/* Side Orders (if any) */}
                                    {sxoList?.length > 0 && (
                                        <div style={{ marginLeft: "15px", marginTop: "2px" }}>
                                            {sxoList?.map((s, i) => (
                                                <div key={i} className="d-flex justify-content-between">
                                                    <span className="text-muted"> {s.m0text.toSwe()}</span>
                                                    <span className="text-muted">{parseInt(s.m0pris).toFixed(2)} SEK</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

    })}
            </BottomSheet>
        )
    }

    const { order00 } = order;
    const isPaid = order00?.paid === "1";
    const amountKr = (parseInt(order00?.belopp) / 100).toFixed(2);

    return (
        <div className="container mt-5">
            <h2 className="text-center fw-bold text-dark mb-4 pt-3">Orderstatus</h2>

            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm p-4">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                        <h4 className="fw-bold mb-2 mb-md-0">
                            Order #{parseInt(order00?.orderid)}
                        </h4>
                        <button
                            className="btn btn-secondary secondaryText d-flex align-items-center"
                            onClick={() => setShowCart(!showCart)}
                        >
                            <i className="bi bi-bag-check me-2"></i> Visa order
                        </button>
                    </div>



                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Bord</span>
                            <span className="fw-bold">{order00?.bord || "Ej angivet"}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Belopp</span>
                            <span className="fw-bold">{amountKr} kr</span>
                        </div>

                        <div
                            className={`alert mt-3 d-flex align-items-center justify-content-between ${
                                isPaid ? "alert-success" : "alert-primary primaryText"
                            }`}
                            role="alert"
                        >
                          <span>
                            {isPaid && "✅ Ordern är betald"}
                              {!isPaid && fetchCount < 4 && (
                                  <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      Hämtar status...
                                  </>
                              )}
                              {!isPaid && fetchCount >=4 && "⚠️ Ordern är ännu inte betald"}
                          </span>
                        </div>

                        <hr className="my-2"/>

                        {/* Buttons based on payment status */}
                        {isPaid ? (
                            <div className="mt-2">
                                <h5 className="mb-2">Skicka kvitto</h5>
                                <button
                                    className="btn btn-primary fw-semibold w-100 primaryText"
                                    onClick={() => setSend(true)}
                                >
                                    <i className="bi bi-receipt me-2"></i>Spara kvitto
                                </button>
                            </div>
                        ) : fetchCount >= 4 ? (
                            <PaymentOptions handle1={handleSwish} handle2={handleViva}/>
                        ) : null}
                    </div>
                </div>
            </div>
            <RecieptModal/>
            <SwishModal show={swish} setShow={setSwish} order={orderId} sum={amountKr}/>
            <OrderModal/>
            <div className="w-100 text-center mt-4">
                <h5 className="text-muted">Sugen på något mer?</h5>
                <button className="btn btn-primary fw-semibold px-4 mt-1 primaryText" onClick={() => {
                    navigate(`/${restaurant}/order`)
                }}>Ny order
                </button>
            </div>
        </div>
    );

    function RecieptModal() {
        const formatPhone = (phone) =>{
            if(phone?.[0] === "4"){
                return `0${phone.substring(2)}`
            }
            return phone
        }
        const [phone, setPhone] = useState(formatPhone(order?.order01?.tele) ?? "");
        const [email, setEmail] = useState("");
        const [message, setMessage] = useState(null); // null when no message shown

        const sendSms = async () => {
            if(phone.length<7){
                setMessage({ok:false, message: "Ofullständigt telefonnummer"})
                return
            }
            const response = await sendText(order.order00?.orderid, phone);
            if (response.ok) {
                setMessage({ ok: true, message: "SMS skickades!" });
            } else {
                console.warn("SMS failed: ", response.error);
                setMessage({ ok: false, message: "SMS kunde inte skickas" });
            }
        };

        const handleEmail = async () => {
            if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
                setMessage({ok:false, message: "Ofullständig epost"})
                return
            }
            const response = await sendEmail(order.order00?.orderid, email);
            if (response.ok) {
                setMessage({ ok: true, message: "E-post skickades!" });
            } else {
                console.warn("Email failed: ", response.error);
                setMessage({ ok: false, message: "E-post kunde inte skickas" });
            }
        };

        return (
            <BottomSheet showModal={send} setShowModal={setSend} headerText="Spara kvitto">
                <div className="d-grid gap-3">

                    {/* ✅ Message Box */}
                    {message && (
                        <div className={`alert ${message.ok ? "alert-success" : "alert-danger"} text-center py-2`}>
                            {message.message}
                        </div>
                    )}
                    {/* Phone input + button */}
                    <div>
                        <label className="form-label mb-1">Telefonnummer</label>
                        <div className="input-group">
                            <input
                                type="tel"
                                className="form-control"
                                placeholder="0701234567"
                                value={phone}
                                onChange={(e) => {
                                    setMessage(null)
                                    setPhone(e.target.value)}
                                }
                            />
                            <button className="btn btn-outline-primary" type="button" onClick={sendSms}>
                                Skicka SMS
                            </button>
                        </div>
                    </div>

                    {/* Email input + button */}
                    <div>
                        <label className="form-label mb-1">E-postadress</label>
                        <div className="input-group">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="namn@example.com"
                                value={email}
                                onChange={(e) => {
                                    setMessage(null)
                                    setEmail(e.target.value)
                                }}
                            />
                            <button className="btn btn-outline-secondary" type="button" onClick={handleEmail}>
                                Skicka E-post
                            </button>
                        </div>
                    </div>

                    {/* View receipt button */}
                    <div>
                        <button className="btn btn-primary primaryText ml-auto" onClick={goToPage}>
                            <i className="bi bi-download" /> Visa kvitto
                        </button>
                    </div>
                </div>
            </BottomSheet>
        );
    }
}
